<div class="functions-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>{{ 'Functions.Title' | translate }}</span>
    </div>

    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Functions.Number' | translate }}</span>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.number }}</td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Functions.Name' | translate }}</span>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Type</span>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ 'Functions.' + element.type | translate }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>
            </div>
        </form>
    </div>
</div>
